import {
    Card,
    Col,
    Progress,
    Radio,
    Row,
    Select,
    Skeleton,
    Tabs,
    Typography,
    Descriptions,
    Table,
    Space ,
    Dropdown,
    MenuProps ,
    Input,
    Menu,
    Button,
  } from "antd";
   
  
  import { DownOutlined, UndoOutlined } from "@ant-design/icons";
  import React, { useContext, useEffect, useState } from "react";
  import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend,  BarChart, Bar, Rectangle , ResponsiveContainer } from "recharts";
  
  import apiPath from "../../constants/apiPath";
  import { AppStateContext } from "../../context/AppContext";
  import { Severty, ShowToast } from "../../helper/toast";
  import useRequest from "../../hooks/useRequest";
  import { useNavigate } from "react-router";
  import { useAuthContext } from "../../context/AuthContext";
  import { Link } from "react-router-dom";
  import lang from "../../helper/langHelper";
  import "../../assets/styles/dashboard.css";
  import moment from "moment";
  import ImportForm from "../../components/ImportForm";
  
  import Plus from "../../assets/images/plus.svg";
  
  import NewHeader from "../../components/layout/NewHeader"; 
const { TabPane } = Tabs;

  
  const { Title, Text } = Typography;
  
  const years = [2024, 2025];
  
  function RewardsStoreIndex() {
    const { setPageHeading, country } = useContext(AppStateContext);
  const [selectedTab, setSelectedTab] = useState();

    const handleTabChange = (status) => {
      setSelectedTab(status);
    };
    const { request } = useRequest();
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [importModal, showImportModal] = useState(false);
    const [year, setYear] = useState(years[0]);
    const [period, setPeriod] = useState("monthly");
    const { userProfile } = useAuthContext();
    const [dashboard, setDashboard] = useState();
    const [listing, setListing] = useState([]);
    const [stockData, setStockData] = useState([]);
    const [extraKeys, setExtraKeys] = useState({});
    const [openPosition, setOpenPositions] = useState();
    const [currency, setCurrency] = useState("USD");
  
    const data = [
      { name: "Jan", uv: 4000, pv: 2400, amt: 2400 },
      { name: "Feb", uv: 3000, pv: 1398, amt: 2210 },
      // Add more data points
    ];
  
    const menu = (
      <Menu
        style={{ width: "70px" }}
        onClick={(e) => {
          fetchWalletInfo(e.key);
          setCurrency(e.key);
        }}
      >
        <Menu.Item key="USD">USD</Menu.Item>
        <Menu.Item key="AED">AED</Menu.Item>
        <Menu.Item key="HKD">HKD</Menu.Item>
        <Menu.Item key="SGD">SGD</Menu.Item>
      </Menu>
    );
  
    const count = [
      {
        today: "Number of Customers",
        title: `${dashboard?.totalCustomer || 0}`,
  
        icon: <i class="fas fa-user-friends"></i>,
        bnb: "bnb2",
        url: "/customer",
        key: "customer-manager",
      },
      {
        today: "Number of Challenges",
        title: `${dashboard?.totalOrders || 0}`,
        icon: <i className="fas fa-people-carry"></i>,
        bnb: "bnb2",
        url: "/order",
        key: "order-manager",
      },
      {
        today: "Number of Rewards Redeemed",
        title: `${dashboard?.totalOrders || 0}`,
        icon: <i className="fas fa-people-carry"></i>,
        bnb: "bnb2",
        url: "/order",
        key: "order-manager",
      },
      {
        today: "Number of Products",
        title: `${dashboard?.totalOrders || 0}`,
        icon: <i className="fas fa-people-carry"></i>,
        bnb: "bnb2",
        url: "/order",
        key: "order-manager",
      },
    ];
  
    const orders = [
      {
        title: "Order id",
        dataIndex: "index",
        key: "index",
        render: (_, { order_id }) =>
          order_id ? <span className="cap">#{order_id}</span> : "-",
      },
      {
        title: "Customer Name",
        dataIndex: "name",
        key: "name",
        render: (_, { user_id }) =>
          user_id ? (
            <div style={{ display: "flex", gap: 2, flexDirection: "column" }}>
              {user_id?.name && <span className="cap">{user_id.name}</span>}
              {user_id?.country_code && user_id?.mobile_number && (
                <span className="cap" style={{ fontSize: "14px", color: "gray" }}>
                  (
                  {user_id.country_code?.includes("+")
                    ? user_id.country_code
                    : "+" + user_id.country_code}
                  ) {user_id.mobile_number}
                </span>
              )}
              {user_id?.email && (
                <span style={{ fontSize: "14px", color: "gray" }}>
                  {user_id.email}
                </span>
              )}
            </div>
          ) : (
            "-"
          ),
        sorter: (a, b) => {
          let nameA = a.user_id?.name;
          let nameB = b.user_id?.name;
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        },
      },
      {
        title: "Total Amount",
        dataIndex: "amount",
        key: "amount",
        render: (_, { amount }) => (
          <span className="cap">{amount?.toFixed(2) ?? 0.0}</span>
        ),
        sorter: (a, b) => {
          let nameA = a.amount;
          let nameB = b.amount;
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        },
      }, 
    ];
  
    const fetchWalletInfo = (currency) => {
      request({
        url: apiPath.getOpenPositions,
        method: "POST",
        data: { currency },
        onSuccess: (data) => {
          if (data.status) {
            setOpenPositions(data);
          } else {
            ShowToast(data?.message, Severty.ERROR);
          }
        },
        onError: (err) => {
          ShowToast(err?.message, Severty.ERROR);
        },
      });
    };
  
    useEffect(() => {
      setPageHeading("Welcome Admin");
      if (!userProfile) return;
  
      setLoading(true);
      request({
        url: apiPath.dashboard + `${year ? `?year=${year}` : ""}`,
        method: "GET",
        onSuccess: ({ data }) => {
          setLoading(false);
          setListing(data?.orders);
          setDashboard(data?.data);
          setExtraKeys(data?.extraKeys?.[0]);
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    }, [userProfile, refresh]);
  
    const [isOpen, setIsOpen] = useState(false);
    const items = [
      {
        label: <a href="" className="drop-dawn-menu">Latest</a>,
        key: '0',
      },
      {
        label: <a href=" " className="drop-dawn-menu">Most Purchased</a>,
        key: '1',
      },
       
      {
        label: <a href=" " className="drop-dawn-menu">Least Purchased</a>,
        key: '3',
      },
    ];
  
  
   
    return (
      <>
        <div className="dashboard-section">
          <div className="container">
            <div className="main-card-section">
              <NewHeader />
              <Card className="criclebox mt-3">
                <div className="table-header-top">
                  <div className="userid-no">
                    <h6>User Id</h6>
                  </div>
                  <div className="right-outer-header">
                    <Button className="primary_btn btnStyle">
                      {lang("reward managers ")}
                    </Button>
                  </div>
                </div>
                <Row gutter={[12, 12]}>
                  <Col span={24} lg={12}>
                    <Card className="table-card mt-3">
                      <div className="card-headered">
                        <div className="card-headding">
                          <h6>Main Product table</h6>
                        </div>
                        <div className="text-head_right_cont">
                          <div className="table-header-drp">
                            <Dropdown
                              className="main-drp-btn"
                              menu={{ items }}
                              trigger={["click"]}
                            >
                              <a
                                className="dropdawn-btn"
                                onClick={(e) => e.preventDefault()}
                              >
                                <Space className="gap-3">
                                  Latest
                                  <DownOutlined />
                                </Space>
                              </a>
                            </Dropdown>
                          </div>
                          <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                              <img src={Plus} />
                            </span>
                            {lang("Add")}
                          </Button>
                        </div>
                      </div>
                      <div className="table-responsive customPagination">
                        <Table
                          loading={loading}
                          columns={orders}
                          dataSource={listing}
                          pagination={false}
                          className="ant-border-space"
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={24} lg={12}>
                    <Card className="table-card mt-3">
                      <div className="card-headered">
                        <div className="card-headding">
                          <h6>Attribute Table</h6>
                        </div>
                        <div className="text-head_right_cont">
                          <div className="table-header-drp">
                            <Dropdown
                              className="main-drp-btn"
                              menu={{ items }}
                              trigger={["click"]}
                            >
                              <a
                                className="dropdawn-btn"
                                onClick={(e) => e.preventDefault()}
                              >
                                <Space className="gap-3">
                                  Latest
                                  <DownOutlined />
                                </Space>
                              </a>
                            </Dropdown>
                          </div>
                          <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                              <img src={Plus} />
                            </span>
                            {lang("Add")}
                          </Button>
                        </div>
                      </div>
                      <div className="table-responsive customPagination">
                        <Table
                          loading={loading}
                          columns={orders}
                          dataSource={listing}
                          pagination={false}
                          className="ant-border-space"
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={24} lg={18}>
                    <Card className="table-card mt-3">
                      <div className="card-headered">
                        <div className="card-headding">
                          <h6>Variant Table</h6>
                        </div>
                        <div className="text-head_right_cont">
                          <div className="table-header-drp">
                            <Dropdown
                              className="main-drp-btn"
                              menu={{ items }}
                              trigger={["click"]}
                            >
                              <a
                                className="dropdawn-btn"
                                onClick={(e) => e.preventDefault()}
                              >
                                <Space className="gap-3">
                                  Latest
                                  <DownOutlined />
                                </Space>
                              </a>
                            </Dropdown>
                          </div>
                          <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                              <img src={Plus} />
                            </span>
                            {lang("Add")}
                          </Button>
                        </div>
                      </div>
                      <div className="table-responsive customPagination">
                        <Table
                          loading={loading}
                          columns={orders}
                          dataSource={listing}
                          pagination={false}
                          className="ant-border-space"
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={24} lg={6}>
                    <Card className="table-card mt-3">
                      <div className="count-box-main">
                        <div class="user-counter-box">
                          <h4>Total active users</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                        <div class="user-counter-box">
                          <h4>Total active users</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                        <div class="user-counter-box">
                          <h4>Total active users</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                        <div class="user-counter-box">
                          <h4>Total active users</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col span={24} lg={18}>
                    <Card className="table-card mt-3">
                      <div className="card-headered">
                        <div className="card-headding">
                          <h6>Coupon Card Table</h6>
                        </div>
                        <div className="text-head_right_cont">
                          <div className="table-header-drp">
                            <Dropdown
                              className="main-drp-btn"
                              menu={{ items }}
                              trigger={["click"]}
                            >
                              <a
                                className="dropdawn-btn"
                                onClick={(e) => e.preventDefault()}
                              >
                                <Space className="gap-3">
                                  Latest
                                  <DownOutlined />
                                </Space>
                              </a>
                            </Dropdown>
                          </div>
                          <Button className="primary_btn btnStyle">
                            <span className="add-Ic">
                              <img src={Plus} />
                            </span>
                            {lang("Add")}
                          </Button>
                        </div>
                      </div>
                      <div className="table-responsive customPagination">
                        <Table
                          loading={loading}
                          columns={orders}
                          dataSource={listing}
                          pagination={false}
                          className="ant-border-space"
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={24} lg={6}>
                    <Card className="table-card mt-3">
                      <div className="count-box-main">
                        <div class="user-counter-box">
                          <h4>Total Coupon</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                        <div class="user-counter-box">
                          <h4>Expired Coupon</h4>
                          <div class="number-of-count">
                            <span>3232</span>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default RewardsStoreIndex;
  